import React, { useEffect, useState } from 'react';
import i18n from '~/components/i18n';
import Layout from '~/components/Layout';
import TableComponent from '~/components/TableComponent';
import { useDebounce } from 'use-lodash-debounce';
import { RouteTypes } from '~/routes/constants';
import { NewsletterQuery } from '~/QueryHooks/NewsLetterQuery';
import { useTranslation } from 'react-i18next';
import { Input } from 'semantic-ui-react';

const getTableColumns = () => [
  {
    name: i18n.t('Status'),
    key: 'openedInApp',
    type: 'newsletter-sent'
  },
  {
    name: i18n.t('Received on'),
    key: 'receivedAt',
    type: 'date',
    format: 'DD.MM.YYYY HH:mm'
  },
  {
    name: i18n.t('Subject'),
    key: 'subject'
  },
  {
    name: i18n.t('Attachment available'),
    key: 'attachment',
    type: 'verified'
  },
  {
    name: i18n.t('Actions')
  }
]

interface INewsletter { }

const Newsletter: React.FunctionComponent<INewsletter> = () => {
  const actions = [
    {
      popupMessage: i18n.t('Show more'),
      type: 'link',
      name: 'eye',
      size: 'large',
      link: RouteTypes.NEWSLETTER_SHOW
    }
  ]
  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 30,
    search: ''
  })
  const [search, setSearch] = useState('');
  const { t } = useTranslation();
  const debouncedSearchValue = useDebounce(search, 300);

  const {
    isLoading: isBusyData,
    data: newsletterData,
    refetch: fetchFilteredData
  } = NewsletterQuery.getNewsLetterList(
    {
      ...dataFiltered,
      page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
    });

  useEffect(() => {
    if (dataFiltered) {
      fetchFilteredData()
    }
  }, [dataFiltered, t])

  useEffect(() => {
    setDataFiltered({ ...dataFiltered, search: debouncedSearchValue, page: 0 });
  }, [debouncedSearchValue]);

  function renderSearch() {
    return (
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Search...')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
    );
  }

  const { filtered, rows } = newsletterData ? newsletterData : { filtered: 0, rows: [] }

  return <Layout
    isBusy={isBusyData}
    filters={renderSearch()}
    segmented
    title={i18n.t('Newsletter')}>
    <TableComponent
      tableColumnHeaders={getTableColumns()}
      rows={rows || []}
      actions={actions}
      total={filtered || 0}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
    />
  </Layout>
}
export default Newsletter
